import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { TextLabel } from '../../../common/typography/typography.styles';
import {
  CompletedIconWrapper,
  ParcelStepInfoPill,
  ParcelStepNumber,
  ParcelStepSeparator,
  ParcelStepTitleBody,
  ParcelStepTitleContainer,
  ParcelStepTooltip,
} from './parcel-step-title.styles';
import { ReactComponent as CompletedIcon } from '../../../assets/checkbox-icon.svg';
import {
  Step,
  toTranslationKey,
} from '../../../models/parcelCreationFlowNavigation';

interface Props {
  step: Step;
  stepIndex: number;
  isActive: boolean;
  isLastStep: boolean;
  isCompleted: boolean;
  tooltip: boolean;
  hideSeparator?: boolean;
  infoPill?: {
    text: string;
  };
}

const ParcelStepTitle = ({
  step,
  stepIndex,
  isActive,
  isLastStep,
  isCompleted,
  tooltip,
  infoPill,
  hideSeparator = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ParcelStepTitleContainer
      $isActive={isActive}
      $isCompleted={isCompleted}>
      <ParcelStepTitleBody data-active={isActive}>
        <ParcelStepNumber>
          {!isCompleted && stepIndex}
          {isCompleted && <CompletedIcon />}
        </ParcelStepNumber>
        <TextLabel>{t(toTranslationKey(step.name))}</TextLabel>
        {infoPill && (
          <ParcelStepInfoPill>
            <CompletedIconWrapper>
              <CompletedIcon />
            </CompletedIconWrapper>
            {infoPill.text}
          </ParcelStepInfoPill>
        )}
      </ParcelStepTitleBody>
      <ParcelStepTooltip>
        {!isLastStep && !hideSeparator && (
          <ParcelStepSeparator
            $tooltip={tooltip}
            $step={stepIndex}
          />
        )}
        {step.name === 'delivery-option' && tooltip && (
          <TextLabel>{t('select_sending_receiving_options')}</TextLabel>
        )}
      </ParcelStepTooltip>
    </ParcelStepTitleContainer>
  );
};

export default observer(ParcelStepTitle);
